import * as autenticacion from './reducers/auth.reducers';
import * as permisos from './reducers/permisos.reducers';
import * as utils from './reducers/utils.reducers';
import * as operacion from './reducers/operacion.reducers';
import * as detalleFactura from './reducers/detalleFactura.reducers'
import { createFeatureSelector } from '@ngrx/store';
import { IOperacion } from 'app/interfaces/interfaces';

export interface AppState {
  empresaSeleccionada: any;
  autenticacionState: autenticacion.State;
  permisosState: permisos.State;
  utils: utils.State,
  operacion: IOperacion,
  detalleFactura: detalleFactura.State
}

export const reducers = {
  autenticacion: autenticacion.authReducer,
  seguridad: permisos.permisosReducer,
  utils: utils.utilsReducer,
  operacion: operacion.Reducer,
  detalleFactura: detalleFactura.DetalleFacturaReducer
};

export const selectAuthState = createFeatureSelector<AppState>('autenticacion');
export const selectPermisosState = createFeatureSelector<AppState>('seguridad');
export const selectUtilsState = createFeatureSelector<AppState>('utils');
export const selectOperacionState = createFeatureSelector<AppState>('operacion');
export const selectDetalleFacturaState = createFeatureSelector<AppState>('detalleFactura');

